import { POST, SUCCESS } from "../../utils/const/http-const";
import { getHeaders } from "../utils";

export async function obtenerInfoGestionarPlataforma() {
    try {
        let data = null;
        let { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/configuracion-empresa-plataforma/obtener-configuracion-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                // body: JSON.stringify({data: 'hello'}),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data = Array.isArray(body) && body.length > 0 ? body[0] : null;
        }
        return data;
    } catch (err) {
        console.log("obtenerInfoGestionarPlataforma err");
        console.log(err);
        return null;
    }
}